function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formConfig, comData, validate, rules } from '../common';
export default {
  name: 'other',
  props: {
    cloneForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    form: {
      handler: function handler(newVal, oldVal) {
        this.$emit('formChange', newVal);
        // console.log('form changed:', newVal, oldVal);
        // 在这里编写你需要的逻辑
      },
      deep: true
    },
    cloneForm: {
      handler: function handler(newForm) {
        var _this$form$customerId;
        this.form = _objectSpread(_objectSpread({}, this.form), newForm);
        this.form.customerId && comData.customersList && this.showCustomersList((_this$form$customerId = this.form.customerId) === null || _this$form$customerId === void 0 ? void 0 : _this$form$customerId.split(',').map(function (j) {
          return Number(j);
        }));
      }
    }
  },
  data: function data() {
    return {
      formConfig: formConfig,
      comData: comData,
      rules: rules,
      form: {
        labelId: [],
        channelIds: []
      }
    };
  },
  methods: {
    validate: validate,
    handleSelectionChange: function handleSelectionChange(list) {
      this.form.customerId = list.map(function (item) {
        return item.id;
      }).join(',');
    },
    /**
     * 回显分销授权列表
     */
    showCustomersList: function showCustomersList(ids) {
      var _this = this;
      comData.customersList.forEach(function (item) {
        if (ids.includes(item.id)) {
          _this.$refs.customersListTableRef.toggleRowSelection(item, true);
        }
      });
    }
  }
};